package com.example.readingnotes.domain.usecase

import com.example.readingnotes.data.remote.api.ApiClient
import com.example.readingnotes.data.remote.dto.ImageConfirmRequestDto
import com.example.readingnotes.data.remote.dto.ImageUploadUrlRequestDto
import com.example.readingnotes.domain.model.PostImage
import io.ktor.client.request.headers
import io.ktor.client.request.put
import io.ktor.client.request.setBody
import io.ktor.client.statement.HttpResponse
import io.ktor.client.statement.bodyAsText
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.withContext

class UploadImageUseCase(
    private val apiClient: ApiClient,
) {
    suspend operator fun invoke(
        fileName: String,
        mimeType: String,
        imageData: ByteArray,
    ): Result<PostImage> =
        withContext(Dispatchers.Default) {
            try {
                // 1. アップロードURLを取得
                val uploadUrlRequest =
                    ImageUploadUrlRequestDto(
                        fileName = fileName,
                        mimeType = mimeType,
                        contentLength = imageData.size,
                    )

                val uploadUrlResponse = apiClient.getImageUploadUrl(uploadUrlRequest)

                // 2. R2に画像をアップロード
                val uploadResponse: HttpResponse =
                    apiClient.httpClient.put(uploadUrlResponse.uploadUrl) {
                        headers {
                            append("Content-Type", mimeType)
                        }
                        setBody(imageData)
                    }

                if (uploadResponse.status.value !in 200..299) {
                    return@withContext Result.failure(
                        Exception(
                            "Failed to upload image: ${uploadResponse.status.value} - ${uploadResponse.bodyAsText()}",
                        ),
                    )
                }

                // 3. アップロード完了を通知
                val confirmRequest =
                    ImageConfirmRequestDto(
                        objectKey = uploadUrlResponse.objectKey,
                    )

                val imageDto = apiClient.confirmImageUpload(confirmRequest)

                // ImageDto doesn't have url field, need to generate it from objectKey
                // For now, use a placeholder URL generation
                val imageUrl = "https://r2.example.com/images/${imageDto.objectKey}"

                val postImage =
                    PostImage(
                        id = imageDto.id,
                        url = imageUrl,
                        originalName = imageDto.originalName,
                        mimeType = imageDto.mimeType,
                        width = imageDto.width,
                        height = imageDto.height,
                    )
                Result.success(postImage)
            } catch (e: Exception) {
                Result.failure(e)
            }
        }
}
